import { MARKETS } from '../shared/markets';

export const Markets = (state = MARKETS, action) => {
    switch (action.type) {
        default:
            return state;
    }
};